import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled, alpha } from '@mui/material';

export interface StyledIconButtonProps {
    variant?: 'contained';
}
type Props = StyledIconButtonProps & IconButtonProps;

export const Component = styled(IconButton)<Props>(({ variant, theme, color }) => ({
    ...(variant === 'contained' &&
        color === 'primary' && {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        }),
    ...(variant === 'contained' &&
        color === 'secondary' && {
            backgroundColor: '#F5F5F5',
            '&:hover': {
                backgroundColor: '#EBEBEB',
            },
        }),
    ...(!variant &&
        color === 'primary' && {
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
            },
        }),
    ...(!variant &&
        color === 'secondary' && {
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
        }),
    '&.MuiIconButton-root': {
        width: 'fit-content',
        '.MuiSvgIcon-fontSizeSmall': {
            fontSize: '20px',
        },
        '.MuiSvgIcon-fontSizeMedium': {
            fontSize: '24px',
        },
        '.MuiSvgIcon-fontSizeLarge': {
            fontSize: '35px',
        },
    },
    '&.MuiIconButton-sizeMedium': {
        padding: '12px',
    },
    '&.MuiIconButton-sizeSmall': {
        padding: '4px',
    },
}));

Component.displayName = 'IconButton';
